import { createAction } from 'redux-actions';

export const REQUEST_FIXTURES = 'REQUEST_FIXTURES';
export const RECEIVE_FIXTURES = 'RECEIVE_FIXTURES';

export const requestFixtures = createAction(REQUEST_FIXTURES);
export const receiveFixtures = createAction(RECEIVE_FIXTURES);



// WEBPACK FOOTER //
// ./src/modules/fixture/actions.js